module.exports = __webpack_public_path__ + "img/3-6681.a490e991.png";